export default 'M10.5 10.5H0V0h10.5zM24 24H13.5V13.5H24zM13.5 0H24v10.5H13.5zm-3 24H0V13.5h10.5z';